export const REDUCER_NAME="storyProductSlice";

export interface iStoryProductRespone {
    storyProductId: string;
    vendorId: string;
    product: string;
    storyProductType: string;
    storyProductUrl: string;
    resoureType: string; 
    status: number;
    created_at: string;
    updated_at: string; 
    resourceType: string;
    images:iStoryProductImages[],
    data: string
    storyType?: string;
    storyUrl?: string;
  }

export interface iStoryProductImages{
  title:string;
  description:string;
  image:string
}

export interface iStoryProductDTO {
    product?: string;
    storyType?: string;
    storyUrl?: string;
    // resoureType?: string; 
    // resourceType?: string;
    Video?: File | string;
    data?: string
}


export interface iStoryProductState {
    storyProductDetail: iStoryProductRespone | null;
    storyProductList: iStoryProductRespone[];
    isLoading: boolean;
    errorMessage: string | null;
    wholesalerStoryProduct: iStoryProductRespone[];
    wholesalerStoryProductById: iStoryProductRespone[];
     successMessage?: string | null;
}